import React from 'react'
import classNames from 'classnames'

import { FormField } from '@/components/forms/FormField'

/**
 * @import import { FilterForm } from '@/components/filters/FilterForm'
 * @param {object} props
 * @param {boolean} [props.small] Caps filter columns at the small grid width
 * @param {boolean} [props.medium] Caps filter columns at the medium grid width
 * @param {boolean} [props.sticky] Pins the bar while scrolling; defaults to true, pass false for static bars
 * @param {node} [props.actions] Buttons rendered in the trailing column
 * @param {boolean|'end'} [props.inlineActions] Flows the actions right after the fields; 'end' pushes them to the row's end
 * @param {Function} [props.onSubmit] Renders a `<form>` and is called on submit with the default prevented
 * @param {string} [props.className] Additional classes on the root element
 * @param {node} props.children Filter fields laid out on the grid
 */
export const FilterForm = ({
  small,
  medium,
  sticky = true,
  actions,
  inlineActions,
  onSubmit,
  className,
  children,
  ...props
}) => {
  const Tag = onSubmit ? 'form' : 'div'

  return (
    <Tag
      className={classNames(
        'filter-form',
        { 'static-filter-form': !sticky, 'no-actions': !actions || inlineActions },
        className
      )}
      onSubmit={
        onSubmit
          ? (event) => {
              event.preventDefault()
              onSubmit(event)
            }
          : undefined
      }
      {...props}
    >
      <div
        className={classNames('filter-grid', {
          'small-grid': small,
          'medium-grid': medium,
          'inline-actions': inlineActions,
          'inline-actions-end': inlineActions === 'end',
        })}
      >
        {children}
        {inlineActions && actions && <div className="filter-actions">{actions}</div>}
      </div>
      {!inlineActions && actions && (
        <div className="filter-buttons">
          <FormField>
            <label className="visibility-hidden">&nbsp;</label>
            <div>{actions}</div>
          </FormField>
        </div>
      )}
    </Tag>
  )
}
